import { Link } from "react-router-dom";
import { Logo } from "./Header";

const LINKS = [
  { label: "Home", to: "/" },
  { label: "Features", to: "/#features" },
  { label: "How It Works", to: "/#how-it-works" },
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Delete Account", to: "/delete-account" },
  { label: "Contact", to: "mailto:info@kensworth.in" },
];

export const Footer = () => (
  <footer className="border-t border-slate-100 bg-white py-10" data-testid="footer">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
        <div>
          <Logo />
          <p className="mt-3 text-sm font-medium text-slate-500" data-testid="footer-tagline">Every Card Matters</p>
        </div>
        <nav className="flex flex-wrap gap-x-8 gap-y-3" aria-label="Footer">
          {LINKS.map((l) =>
            l.to.startsWith("mailto:") ? (
              <a key={l.label} href={l.to} data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}-link`} className="text-sm font-medium text-slate-600 transition-colors hover:text-toto-blue">
                {l.label}
              </a>
            ) : (
              <Link key={l.label} to={l.to} data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}-link`} className="text-sm font-medium text-slate-600 transition-colors hover:text-toto-blue">
                {l.label}
              </Link>
            ),
          )}
        </nav>
      </div>
      <div className="mt-10 border-t border-slate-100 pt-6 text-sm text-slate-400">
        © {new Date().getFullYear()} TOTO. All rights reserved.
      </div>
    </div>
  </footer>
);
